import { Home } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { UseQueryOptions, useQuery } from 'react-query'
import { getQueryParams } from 'utils/getQueryParams'

type HomeListParams = {
  isGroupUserManagement?: boolean
}

type UseHomesListProps = {
  options?: Pick<UseQueryOptions<{ result: Home[] }>, 'onSuccess'>
  params?: HomeListParams
}

type UseHomesListReturn = {
  homes: Home[]
  isLoading: boolean
}

const HOMES_URL = '/api/list/homes'

const useHomesList = ({
  options,
  params,
}: UseHomesListProps): UseHomesListReturn => {
  const queryParams = getQueryParams(params || {})
  const { data, isLoading } = useQuery<{ result: Home[] }>(
    ['homes', params],
    () => getJSON({ url: `${HOMES_URL}?${queryParams}` }),
    options
  )

  const homes = data?.result

  return {
    homes: homes || [],
    isLoading,
  }
}

export default useHomesList
